"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FormComponent = /*#__PURE__*/function () {
  function FormComponent() {
    _classCallCheck(this, FormComponent);
    this.init();
    this.initNetteFormValidation();
    this.imageDimensions = {};
    this.checkImageDimensions();

    // AJAX FORM SENT
    var submitCurrentValue = "";
    $.nette.ext("genericFormAjax", {
      before: function before(jqXHR, settings) {
        if (settings.hasOwnProperty("nette")) {
          submitCurrentValue = $(settings.nette.el).val();
          $(settings.nette.el).addClass("sending");
        }
      },
      complete: function complete(jqXHR, status, settings) {
        if (settings.hasOwnProperty("nette")) {
          $(settings.nette.el).val(submitCurrentValue);
          $(settings.nette.el).removeClass("sending");
        }
      }
    });
    var _this = this;
    Nette.validators.AppFormsValidationRules_validateImageDimensions = function (elem, args, file) {
      console.log(elem, args, file);
      var id = $(elem).attr("id");
      var result = true;

      // CHECK DIMENSIONS
      if (typeof _this.imageDimensions[id] !== "undefined") {
        if (args.width !== _this.imageDimensions[id].width) {
          result = false;
        }
        if (args.height !== _this.imageDimensions[id].height) {
          result = false;
        }
      }
      return result;
    };
    Nette.validators.AppFormsValidationRules_validateFileType = function (elem, args, val) {
      console.log(elem);
      console.log(args);
      console.log(val);
      var file = val[0];
      console.log(file);
      if (file.type !== args) {
        return false;
      }
      return true;
    };
    if ($(".form-errors", "html").length >= 1) {
      var errMessageElement = $(".form-errors:first-of-type", "html");
      $([document.documentElement, document.body]).animate({
        scrollTop: errMessageElement.offset().top
      }, 2000);
    }
  }
  return _createClass(FormComponent, [{
    key: "checkImageDimensions",
    value: function checkImageDimensions() {
      var _this = this;
      $(document).on("change", ".checkImageDimensions", function () {
        var id = $(this).attr("id");
        var img = new Image();
        var file = this.files[0];
        img.src = window.URL.createObjectURL(file);
        img.onload = function () {
          _this.imageDimensions[id] = {
            width: img.width,
            height: img.height
          };
        };
      });
    }

    /**
     * Nette Form Validation
     */
  }, {
    key: "initNetteFormValidation",
    value: function initNetteFormValidation() {
      Nette.showFormErrors = function (form, errors) {
        var errorFind = false;
        var validationType = $(form).attr("data-validationtype");

        // REMOVE ALL ERRORS FROM FORM
        $(".wrapper-form-input", form).removeClass("error");
        $(".error-text", form).remove();
        switch (validationType) {
          case "fields":
            errors.forEach(function (error) {
              errorFind = true;
              var field = $(error.element, form);
              var wrapper = field.parents(".wrapper-form-input");
              wrapper.addClass("error"); // SET STYLE AS INVALID FIELD
              // ADD ERROR MESSAGE TO FIELD
              wrapper.prepend("<div class='error-text'>" + error.message + "</div>");
            });
        }
        if (errorFind === true) {
          if ($(".error-text", "html").length >= 1) {
            var errMessageElement = $(".error-text:first-of-type", "html");
            $([document.documentElement, document.body]).animate({
              scrollTop: errMessageElement.offset().top
            }, 2000);
          }
        }
      };
    }
  }, {
    key: "init",
    value: function init() {}
  }]);
}();